export default __webpack_public_path__ + "static/media/scales.04c01183.svg";